import { validateCPF } from "@/utils/validateCPF";
import * as Yup from "yup";

export const RegisterUserFormValidationSchema = (isNew: boolean) =>
  Yup.object().shape({
    lastName: Yup.string().min(3, "Sobrenome Inválido").required("Sobrenome é obrigatório"),
    name: Yup.string().min(3, "Nome inválido").required("Nome é obrigatório"),
    email: Yup.string().email("Email inválido").required("Email é obrigatório"),
    password: Yup.string().when([], {
      is: () => isNew,
      then: (schema) =>
        schema
          .min(6, "A senha deve ter no mínimo 6 caracteres")
          .required("Senha é obrigatória"),
      otherwise: (schema) =>
        schema.min(6, "A senha deve ter no mínimo 6 caracteres").notRequired(),
    }),
    confirmPassword: Yup.string().when([], {
      is: () => isNew,
      then: (schema) =>
        schema
          .oneOf([Yup.ref("password")], "As senhas não coincidem")
          .required("Confirmação de senha é obrigatória"),
      otherwise: (schema) =>
        schema.min(6, "A senha deve ter no mínimo 6 caracteres").notRequired(),
    }),
    document: Yup.string()
      .required("CPF é obrigatório")
      .min(11, "CPF incompleto")
      .test("valid-cpf", "CPF Inválido", (value) => validateCPF(value || "")),
    cellphone: Yup.string()
      .matches(/\(\d{2}\)\s\d{4,5}-\d{4}/, "Telefone inválido")
      .min(11, "Telefone incompleto")
      .required("Telefone é obrigatório"),
    roles: Yup.array()
      .min(1, "Pelo menos um cargo deve ser selecionado")
      .required("Cargo é obrigatório")
      .test("roles-required", "Pelo menos um cargo deve ser selecionado", (value) => {
        return Array.isArray(value) && value.length > 0;
      }),
  });
